import { keyframes, styled } from "styled-components"
import { FooterTitle } from "../../pages/Home/styles";
import { RxHamburgerMenu } from "react-icons/rx"
import { useState } from "react";

const Container = styled.div`
    width: 100%;
    padding: 2rem;
    display: flex;
    height: 6rem;

    align-items: center;

    font-family: ${({ theme }) => theme.fonts.main};

    @media screen and (max-width: 1100px) {
        padding: 1rem;
    }
`;

const Nav = styled.nav`
    flex: 1;
    display: flex;
    justify-content: center;

    ul {
        display: flex;
        flex-direction: row;
        gap: 70px;
        
        @media screen and (max-width: 600px) {
            flex-direction: column;
            height: 400px;
            margin: auto 0;
        }
    }

    @media screen and (max-width: 600px) {
        display: none;
        /* position: fixed;
        background-color: white;
        width: 100%;
        height: 100vh;
        top: 0;
        left: 0;
        font-size: 2rem; */
    }
`;

const Item = styled.li`
    a {
        position: relative;
        transition: all 200ms;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            bottom: 0;
            width: 0;
            height: 1px;
            background-color: ${({ theme }) => theme.colors.hoverPrimary};
            transition: all 200ms;
        }

        &:hover {
            color: ${({ theme }) => theme.colors.hoverPrimary};

            &::before {
                width: 100%;
            }
        }
    }
`;

const down = keyframes`
    from {
        opacity: 0;
        transform: translateY(-100%);
    }
    
    to {
        opacity: 1;
        transform: translateY(0);
    }
`

const MenuContainer = styled.div`
    font-size: 1.5rem;
    cursor: pointer;

    transform: translateY(-100%);

    animation: ${down} 200ms ease-in-out forwards;

    position: fixed;

    display: flex;
    flex-direction: row;
    background-color: white;

    align-items: center;
    justify-content: center;
    
    width: 100%;
    height: 100vh;

    top: 0;
    left: 0;
    font-size: 2rem;

    ul {
        display: flex;
        flex-direction: column;
        gap: 30px;
    }
`;

const MenuButton = styled(RxHamburgerMenu)`
    margin-left: auto;
    font-size: 1.5rem;
    cursor: pointer;

    @media screen and (min-width: 600px) {
        display: none;
    }
`;

const CloseButton = styled.span`
    position: absolute;
    left: 10px;
    top: 10px;
`;

export function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const handleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    }

    return (
        <Container>
            <FooterTitle size="1">
                David Esdras
            </FooterTitle>
            <Nav>
                <ul>
                    <Item>
                        <a href="#who-i-am">
                            Me conheça
                        </a>
                    </Item>
                    <Item>
                        <a href="#my-projects">
                            Meus projetos
                        </a>
                    </Item>
                    <Item>
                        <a href="#contact-me">
                            Entre em contato
                        </a>
                    </Item>
                </ul>
            </Nav>
            <MenuButton onClick={handleMenu} />
            {isMenuOpen && (
                <MenuContainer>
                    <CloseButton onClick={handleMenu}>
                        X
                    </CloseButton>
                    <ul>
                        <Item onClick={handleMenu}>
                            <a href="#who-i-am">
                                Me conheça
                            </a>
                        </Item>
                        <Item onClick={handleMenu}>
                            <a href="#my-projects">
                                Meus projetos
                            </a>
                        </Item>
                        <Item onClick={handleMenu}>
                            <a href="#contact-me">
                                Entre em contato
                            </a>
                        </Item>
                    </ul>
                </MenuContainer>
            )}
        </Container>
    )
}